import React, { useEffect, useState } from "react";
import DropDown from "../UI/Inputs/DropDown";
import Button from "../UI/Buttons/Button";
import showToast from "../../Helpers/toast";
import useApi from "../../Hooks/useApi";

const INITIAL = {
  userId: 0,
  userType: "" /*,
     "permissions": [
      0
    ] */,
};

const AssignRole = ({ user, onClose, refetch }) => {
  const { userId, userType } = user;

  const [roleId, setRoleId] = useState("");
  const [roles, setRoles] = useState([]);
  const { request } = useApi();

  const fetchRoles = async () => {
    try {
      const response = await request("GET", "/v1/roles");
      setRoles(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const deletePreviousUserType = () => {
    try {
      const prevRoleId = roles.find((role) => role.name == userType)?.id;

      const response =
        prevRoleId &&
        request("DELETE", `/v1/rbac/users/roles/${userId}/${prevRoleId}`);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAssign = async ({}) => {
    if (userId && roleId) {
      userType && deletePreviousUserType();

      try {
        const response = await request(
          "POST",
          `/v1/rbac/users/roles/${userId}/${roleId}`
        );

        onClose();
        refetch();
        showToast({ message: response?.message });
      } catch (error) {
        showToast({
          message: error?.response?.data?.message || `Role update failed.`,
          type: "error",
        });
      }
    } else {
      showToast({ message: "Enter valid role!", type: "error" });
    }
  };

  return (
    <div className=" space-x-2 space-y-2 ">
      <div className=" pl-3 pr-1 border-2 pb-2">
        <DropDown
          label="Role"
          placeholder={"Select Role"}
          name="userType"
          onValueChange={(value) => setRoleId(value)}
          value={roleId}
          options={roles.map((role) => ({
            name: role.name,
            value: role.id,
          }))}
        />
      </div>

      <div className="col-span-5 py-2 space-y-2">
        <Button type={"full"} handler={handleAssign} label={"Assign"} />
      </div>
    </div>
  );
};

export default AssignRole;
